export const ACCOUNT_PROFILE = 'account.profile';
export const ACCOUNT_COMMON = 'account.common';

export const lblProfileSurveyHi = 'lbl_profile_survey_hi';
export const lblProfileSurveyHeader = 'lbl_profile_survey_header';
export const lblProfileAboutYouModalHeading = 'lbl_profile_about_you_modal_heading';
export const lblProfileMyPlaceRewardsInfo = 'lbl_profile_my_place_rewards_info';
export const lblProfileEditBirthdayHeading = 'lbl_profile_edit_birthday_heading';
export const lblProfileAirMiles = 'lbl_profile_air_miles';
export const lblProfileSurveySelectOne = 'lbl_profile_survey_select_one';
export const lblProfileSurveySelectAll = 'lbl_profile_survey_select_all';

export const lblProfileAboutYouTitle = 'lbl_profile_about_you_title';
export const lblProfileUpdateInfo = 'lbl_profile_update_info';
export const lblProfileAboutYouDescribe = 'lbl_profile_about_you_describe';
export const lblProfileAboutYouShopping = 'lbl_profile_about_you_shopping';

export const lblProfileEditBirthdayInfo = 'lbl_profile_edit_birthday_info';
export const lblProfileAddBirthdayInfo = 'lbl_profile_add_birthday_info';
export const lblProfileBirthdaySavings = 'lbl_profile_birthday_savings';

export const lblProfileChangePassword = 'lbl_profile_change_password';
export const lblProfileChangeYourPassword = 'lbl_profile_change_your_password';
export const lblProfilePasswordInfoLine1 = 'lbl_profile_password_info_line1';
export const lblProfilePasswordInfoLine2 = 'lbl_profile_password_info_line2';

export const lblProfileHeading = 'lbl_profile_heading';
export const lblProfileMailingAddress = 'lbl_profile_mailing_address';

export const lblCommonMyFavoriteStore = 'lbl_common_myFavoriteStore';
export const lblCommonAccessBuyOnline = 'lbl_common_accessBuyOnline';
export const lblCommonFavStoreNotAdded = 'lbl_common_favStoreNotAdded';

export const lblProfilePersonalInformation = 'lbl_profile_personal_information';
export const lblProfileEditPersonalInfo = 'lbl_profile_edit_personal_info';
export const lblProfileEditMailingInfo = 'lbl_profile_edit_mailing_info';

export const lblProfileEnhanceExperience = 'lbl_profile_Enhance_Experience';
export const lblProfileProfileCompletionExclamation = 'lbl_profile_profileCompletionExclamation';
export const lblProfileProfileCompletionMessage = 'lbl_profile_profileCompletionMessage';
export const lblProfileGetMorePoints = 'lbl_profile_getMorePoints';
export const lblProfileGetMorePointsLink = 'lbl_profile_getMorePointsLink';
export const lblProfileProfileInCompleteMessage = 'lbl_profile_profileInCompleteMessage';
export const lblProfileMailingAddressDescription = 'lbl_profile_mailingAddressDescription';
export const lblProfileFavStoreDescription = 'lbl_profile_favStoreDescription';
export const lblProfileUserBirthdayDescription = 'lbl_profile_userBirthdayDescription';
export const lblProfileAboutYourselfDescription = 'lbl_profile_aboutYourselfDescription';
export const lblProfileProfileActivityCompleted = 'lbl_profile_profileActivityCompleted';
export const lblCommonUpdateFavoriteStore = 'lbl_common_updateFavoriteStore';
export const lblCommonAddAStore = 'lbl_common_addAStore';
export const lblProfileSuccessMsg = 'lbl_profile_successMessage';

export const lblChangePwdHelpText = 'lbl_changePassword_helpText';

const MyProfileLabels = {
  account: {
    profile: {
      [lblProfileSurveyHi]: 'Hi',
      [lblProfileSurveyHeader]:
        'Take a 5-second survey to make your shopping experience even better',
      [lblProfileAboutYouModalHeading]: 'MORE ABOUT YOU',
      [lblProfileMyPlaceRewardsInfo]: 'My Place Rewards #',
      [lblProfileEditBirthdayHeading]: 'Birthday:',
      [lblProfileAirMiles]: 'Air Miles #:',
      [lblProfileSurveySelectOne]: 'SELECT ONE',
      [lblProfileSurveySelectAll]: 'SELECT ALL THAT APPLY',
      [lblProfileAboutYouTitle]: 'More About You',
      [lblProfileUpdateInfo]: 'UPDATE INFO',
      [lblProfileAboutYouDescribe]: 'I describe myself as',
      [lblProfileAboutYouShopping]: 'Shopping for',

      [lblProfileEditBirthdayInfo]: 'EDIT BIRTHDAY INFO',
      [lblProfileAddBirthdayInfo]: 'ADD BIRTHDAY INFO',
      [lblProfileBirthdaySavings]: 'Birthday Savings',

      [lblProfileChangePassword]: 'CHANGE PASSWORD',
      [lblProfileChangeYourPassword]: 'Need to change your password?',
      [lblProfilePasswordInfoLine1]:
        'Password must contain at least 8 characters, 1 uppercase letter, 1 number and 1 special character. It cannot be your email address or a recently used password.',
      [lblProfilePasswordInfoLine2]: '',

      [lblProfileHeading]: 'Profile Information',
      [lblProfileMailingAddress]: 'Mailing Address',

      [lblProfilePersonalInformation]: 'Personal Information',
      [lblProfileEditPersonalInfo]: 'EDIT PERSONAL INFO',
      [lblProfileEditMailingInfo]: 'EDIT MAILING ADDRESS',

      [lblProfileEnhanceExperience]: 'Complete Your Profile',
      [lblProfileProfileCompletionExclamation]: 'Yay!',
      [lblProfileProfileCompletionMessage]: 'Your profile is 100% complete.',
      [lblProfileGetMorePoints]: 'Earn even more points ',
      [lblProfileGetMorePointsLink]: 'here.',
      [lblProfileProfileInCompleteMessage]:
        'Improve your shopping experience by adding even more info.',
      [lblProfileMailingAddressDescription]: 'Add Mailing Address',
      [lblProfileFavStoreDescription]: 'Add Your Favorite Store',
      [lblProfileUserBirthdayDescription]: 'Add Your Birthday',
      [lblProfileAboutYourselfDescription]: 'Take A 5-Second Survey',
      [lblProfileProfileActivityCompleted]: 'Added!',
    },
    common: {
      [lblCommonMyFavoriteStore]: 'My Favorite Store',
      [lblCommonAccessBuyOnline]:
        'Add your favorite store for easier shopping and access to Buy Online Pick Up In Store info, store hours and directions.',
      [lblCommonFavStoreNotAdded]: "You haven't added a favorite store yet.",
      [lblCommonUpdateFavoriteStore]: 'Update Favorite Store',
      [lblCommonAddAStore]: 'Add A Store',
    },
  },
};

export const ChangePwdLabels = {
  account: {
    common: {
      [lblChangePwdHelpText]: 'Start shopping to earn my place rewards points !',
    },
  },
};

export const ProfileInformationLabels = {
  account: {
    profile: {
      [lblProfileSuccessMsg]: 'Your account has been updated',
    },
  },
};
export default MyProfileLabels;
